module.exports = __webpack_public_path__ + "static/img/1.958a9e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/upload/commonality/20251009/1.jpg
// module id = hvkC
// module chunks = 7